import MultiSelectFilter from '../../components/MultiSelectFilter';
import {
  ACENTO, APROVECHAMIENTOS, CHIP, ROTULO, SIN_FILTROS, TIPOS, UTILIDADES, VENTAS, hayFiltros,
} from './comun';

/**
 * Los filtros del Inicio: debajo del saludo del ejecutivo y, desde el
 * 28-sep-2026, arriba en el Overview, en «Calificación del equipo». Mueven TODAS
 * las cifras de la pantalla, incluido el promedio del equipo.
 *
 * Es UN componente para las dos pantallas a propósito: el supervisor que filtra
 * «públicas» tiene que ver los mismos botones, con el mismo significado, que el
 * ejecutivo con quien va a hablar de esa nota.
 */
export default function Filtros({ valor, onCambio, categorias }) {
  const set = (k, v) => onCambio({ ...valor, [k]: v });
  const grupo = (etiqueta, opciones, clave) => (
    <div style={{ display: 'inline-flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
      <span style={{ ...ROTULO, marginRight: 2 }}>{etiqueta}</span>
      <button type="button" style={CHIP(!valor[clave])} onClick={() => set(clave, null)}>Todas</button>
      {opciones.map(([k, t]) => (
        <button key={k} type="button" style={CHIP(valor[clave] === k)}
                onClick={() => set(clave, valor[clave] === k ? null : k)}>{t}</button>
      ))}
    </div>
  );
  // Tipo y venta se suman: cada botón se prende y se apaga solo, y «Todas» es
  // la lista vacía. Mismo comportamiento que los pre-filtros de admin.
  const grupoMultiple = (etiqueta, opciones, clave) => {
    const elegidos = valor[clave] || [];
    const alternar = (k) => set(clave, elegidos.includes(k) ? elegidos.filter((x) => x !== k) : [...elegidos, k]);
    return (
      <div style={{ display: 'inline-flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
        <span style={{ ...ROTULO, marginRight: 2 }}>{etiqueta}</span>
        <button type="button" style={CHIP(!elegidos.length)} onClick={() => set(clave, [])}>Todas</button>
        {opciones.map(([k, t]) => (
          <button key={k} type="button" style={CHIP(elegidos.includes(k))} aria-pressed={elegidos.includes(k)}
                  onClick={() => alternar(k)}>{t}</button>
        ))}
      </div>
    );
  };
  return (
    <div style={{ marginTop: 14, display: 'flex', gap: '10px 18px', flexWrap: 'wrap', alignItems: 'center' }}>
      {grupoMultiple('Tipo', TIPOS, 'tipo')}
      {grupo('Utilidad', UTILIDADES, 'utilidad')}
      {grupoMultiple('Venta', VENTAS, 'venta')}
      {categorias.length > 0 && (
        <MultiSelectFilter label="Toda categoría" options={categorias.map((c) => c.etiqueta)}
                           value={valor.categoria} onChange={(v) => set('categoria', v)} />
      )}
      <select className="filter-select" value={valor.aprovechamiento || ''}
              onChange={(e) => set('aprovechamiento', e.target.value || null)}
              title="Las no aprovechables no llevan calificación: no hubo intercambio humano que evaluar">
        <option value="">Todo aprovechamiento</option>
        {APROVECHAMIENTOS.map(([k, t]) => <option key={k} value={k}>{t}</option>)}
      </select>
      {hayFiltros(valor) && (
        <button type="button" onClick={() => onCambio(SIN_FILTROS)}
                style={{ background: 'none', border: 'none', padding: 0, font: 'inherit', fontSize: 12.5,
                         color: ACENTO, textDecoration: 'underline', cursor: 'pointer' }}>
          Quitar filtros
        </button>
      )}
      {/* Sin filtro de salientes, a propósito, y se dice para que nadie lo
          busque: la calificación v2 evalúa atención entrante. */}
      <span style={{ color: '#5c5c6b', fontSize: 11.5, flexBasis: '100%' }}>
        Las llamadas salientes no se califican en la v2: la boleta evalúa la atención entrante.
      </span>
    </div>
  );
}
